module.exports = __webpack_public_path__ + "static/media/wijn-rose-glas.bd601615.png";